import type {InjectionKey, Ref} from "vue";

export const CheckboxGroupValueKey: InjectionKey<Ref<any[]>> = Symbol("graphiteCheckboxGroupValue");
export const CheckboxGroupTriggerChangeKey: InjectionKey<(val: any[]) => void> = Symbol(
  "graphiteCheckboxGroupTriggerChange",
);
